export default __webpack_public_path__ + "static/media/video.2493964e.svg";